import { mapActions } from 'pinia';
import {
    findExistingViewerPane,
    getReusableDatasetPackage,
    resolveViewComponent
} from 'js/viewers/viewNavigation';
import { useSmartviewStore } from 'store/pinia/useSmartviewStore';
import { deactivatePhotoWorkspaces } from 'components/CesiumViewer/js/photoWorkspace';

export default {
    methods: {
        ...mapActions(useSmartviewStore, [
            'replaceViews',
            'replaceFirstView',
            'addToStartViews',
            'addToEndViews',
            'replaceLastView'
        ]),

        changeViewMain(view) {
            if (!view) {
                return;
            }

            deactivatePhotoWorkspaces(this.viewsOnPage);
            const existingPane = findExistingViewerPane(
                this.viewsOnPage,
                view.uuid
            );
            this.replaceViews(
                existingPane || this.createViewForSelection(view)
            );
        },
        changeViewLeft(view) {
            if (view) {
                deactivatePhotoWorkspaces(this.viewsOnPage);
                if (this.viewsOnPage.length === 1) {
                    this.addToStartViews(this.createViewForSelection(view));
                } else {
                    this.replaceFirstView(this.createViewForSelection(view));
                }
            }
        },
        changeViewRight(view) {
            if (view) {
                deactivatePhotoWorkspaces(this.viewsOnPage);
                if (this.viewsOnPage.length === 1) {
                    this.addToEndViews(this.createViewForSelection(view));
                } else {
                    this.replaceLastView(this.createViewForSelection(view));
                }
            }
        },
        createViewForSelection(view) {
            const component = resolveViewComponent(view?.type);
            const datasetPackage = component
                ? getReusableDatasetPackage(
                      this.selectedViewDetails?.datasetPackage,
                      view
                  )
                : null;

            return this.createNewView(
                view?.uuid,
                datasetPackage ? component : null,
                datasetPackage
            );
        },
        /**
         * Returns a view object to put into the 'views' array in the smartview vuex store
         *
         * @param {string} uuid viewUuid for the view
         * @param {string|null} component to load for the view
         * @returns {object} view object
         * @author Conor Brosnan <c.brosnan@nationaldrones.com>
         */
        createNewView(uuid, component = null, datasetPackage = null) {
            return {
                component: component || 'Loading',
                datasetPackage,
                viewUUID: uuid,
                style: null,
                class: null,
                id: this.getId(),
                urlParam: null,
                state: datasetPackage ? null : 'Loading',
                isFavourite: false,
                stateProps: {},
                enableReports: !(
                    component === 'inspection_view' ||
                    component === 'thermal_inspection_view'
                ),
                siteSelectorValue: this.sites_select
            };
        }
    }
};
